<template>
    <div class="max-w-2xl mx-auto">
        <bubble class="py-4 px-2 w-full mt-16">
            <template #image>
                <img :src="bubbleImg" class="w-16 sm:w-20" />
            </template>
            <div class="text-red text-3xl px-4 py-2 leading-tight">
                {{ $t('site.beyond.sales.period') }}
            </div>
        </bubble>
    </div>
</template>

<script>
import bubble from '@/components/bubble.vue';
import img2s112 from '@/assets/img/2-112.png';
export default {
    components: { bubble },
    created() {
        this.bubbleImg = img2s112;
    }
};
</script>
